import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

interface Props {
  parentIndex: number;
}

export default function GuestHotelTable(props: Props) {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const name: any = `hotelSales.${props.parentIndex}.hotelSaleGuests`;

  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const columns: IColumn<any>[] = [
    {
      header: t('common:lead_guest'),
      accessorKey: 'isLead',
      minSize: 88,
      size: 88,
      dataType: ColumnDataType.checkbox,
    },
    {
      header: t('common:guest'),
      accessorKey: 'guestName',
      minSize: 250,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:guest_preferences'),
      accessorKey: 'guestPreferences',
      minSize: 100,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
      maxTags: 2,
    },
    {
      header: t('guest:booking_preferences'),
      accessorKey: 'preferences',
      minSize: 100,
      dataType: ColumnDataType.tags,
      tagKeyName: 'label',
      maxTags: 2,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={fields}
        dispatch={() => {}}
        disabled
        name={name}
        uniqueRowKey="customId"
      />
    </div>
  );
}
